/* =============================================================
   P0.7 — GEF Medica PDP back-in-stock waitlist form
   Submits subscriber email + product handle to Klaviyo via the
   public Client Profiles API (https://a.klaviyo.com/client/...).
   Sets profile properties so the back-in-stock flow can match.
   ============================================================= */
(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = (window.GEF_KLAVIYO_COMPANY_ID || 'SANjvd');
  var KLAVIYO_REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID);

  function isValidEmail(value) {
    if (!value) return false;
    // simple RFC-ish guard, server still validates
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function disableForm(form, busy) {
    var submit = form.querySelector('[data-restock-submit]');
    var input = form.querySelector('[data-restock-input]');
    if (submit) submit.disabled = !!busy;
    if (input) input.disabled = !!busy;
    if (submit) {
      submit.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function showSuccess(form) {
    var success = form.querySelector('[data-restock-success]');
    var error = form.querySelector('[data-restock-error]');
    if (success) success.hidden = false;
    if (error) error.hidden = true;
    // hide the field row after success
    var fieldRow = form.querySelector('.gef-cd-restock__field-row');
    if (fieldRow) fieldRow.style.display = 'none';
    var legal = form.querySelector('.gef-cd-restock__legal');
    if (legal) legal.style.display = 'none';
  }

  function showError(form) {
    var success = form.querySelector('[data-restock-success]');
    var error = form.querySelector('[data-restock-error]');
    if (error) error.hidden = false;
    if (success) success.hidden = true;
  }

  function submitToKlaviyo(email, productHandle, productTitle) {
    var safeHandle = String(productHandle || '').toLowerCase().replace(/[^a-z0-9-_]/g, '-');
    var propertyKey = 'restock_interest_' + safeHandle;
    var properties = {
      restock_last_request_handle: productHandle,
      restock_last_request_title: productTitle,
      restock_last_request_ts: nowIso()
    };
    properties[propertyKey] = nowIso();

    var payload = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          properties: properties
        }
      }
    };

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit'
    }).then(function (res) {
      // Klaviyo client API returns 202 on success; some 4xx are "already exists"
      // which is still semantic success for us. Anything 5xx = error.
      if (res.status >= 500) {
        throw new Error('Klaviyo 5xx ' + res.status);
      }
      return res;
    });
  }

  function bindForm(form) {
    if (form.dataset.restockBound === '1') return;
    form.dataset.restockBound = '1';

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = form.querySelector('[data-restock-input]');
      var email = input ? String(input.value || '').trim() : '';

      if (!isValidEmail(email)) {
        showError(form);
        if (input) {
          input.focus();
          input.setAttribute('aria-invalid', 'true');
        }
        return;
      }

      var productHandle = form.dataset.productHandle || '';
      var productTitle = form.dataset.productTitle || '';

      disableForm(form, true);

      submitToKlaviyo(email, productHandle, productTitle).then(function () {
        showSuccess(form);
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'gef_restock_signup',
            product_handle: productHandle,
            product_title: productTitle
          });
        }
      }).catch(function () {
        showError(form);
        disableForm(form, false);
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-restock-form]');
    forms.forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // expose for sections.load events (Shopify theme editor)
  document.addEventListener('shopify:section:load', init);
})();
